import requestFunctions from "../../functions/requestFunctions";


export const state = {

  CONTACTS_BLACKLIST_ITEM: {},
  CONTACTS_BLACKLIST_LIST: [],
  
  CONTACTS_BLACKLIST_TABLE_DATA: [],
  CONTACTS_BLACKLIST_LIST_DATA: [],
  CONTACTS_BLACKLIST_TOTAL_ROWS: 0

}

export const getters = {
  GET_CONTACTS_BLACKLIST_ITEM: (state) => {
    return state.CONTACTS_BLACKLIST_ITEM;
  },
  GET_CONTACTS_BLACKLIST_LIST: (state) => {
    return state.CONTACTS_BLACKLIST_LIST;
  },
  GET_CONTACTS_BLACKLIST_TABLE_DATA: (state) => {
    return state.CONTACTS_BLACKLIST_TABLE_DATA;
  },
  GET_CONTACTS_BLACKLIST_LIST_DATA: (state) => {
    return state.CONTACTS_BLACKLIST_LIST_DATA;
  },
  GET_CONTACTS_BLACKLIST_TOTAL_ROWS: (state) => {
    return state.CONTACTS_BLACKLIST_TOTAL_ROWS;
  }
}

export const mutations = {
  UPDATE_CONTACTS_BLACKLIST_ITEM(state, item) {
    state.CONTACTS_BLACKLIST_ITEM = item;
  },
  UPDATE_CONTACTS_BLACKLIST_LIST(state, list) {

    state.CONTACTS_BLACKLIST_LIST = list.total;
    state.CONTACTS_BLACKLIST_TABLE_DATA = [];
    state.CONTACTS_BLACKLIST_LIST_DATA = [];

    state.CONTACTS_BLACKLIST_TOTAL_ROWS = list.total;
    list = list.data;

    list.forEach(el => {

      state.CONTACTS_BLACKLIST_TABLE_DATA.push({
        'created_at' : el.created_at,
        'id'    : el.id,
        'phone' : el.phone,
        'uuid'  : el.uuid
      });

      state.CONTACTS_BLACKLIST_LIST_DATA.push({
        id    : el.id,
        phone : el.phone,
      });

    });
  },
}

export const actions = {

  async FETCH_CONTACTS_BLACKLIST_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/blacklist/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_BLACKLIST_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_BLACKLIST_LIST({ commit }, payload = {}) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/blacklist';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CONTACTS_BLACKLIST_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_CONTACTS_BLACKLIST_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/blacklist';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_BLACKLIST_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/blacklist/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_CONTACTS_BLACKLIST_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/contacts/blacklist/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}